export default __webpack_public_path__ + "static/media/i (26).d374fd9e.jpg";